<div class="position-relative w-100" style="max-width: 300px;">
    <h6 class="m-0 color-whaleTail" [attr.title]="getMetricToolTip(data)">{{ getMetricDisplayName(data) }}</h6>
    <div [id]="itemId + '_valueWrapper'" class="d-flex justify-content-between align-items-end mb-2" style="position: relative;">
        <h3 [id]="itemId + '_value'" class="h3 m-0">{{data.DisplayValue}}</h3>
        <div 
            #canvasContainer
            class="position-absolute bg-white"
            style="top: 0; right: 0;"
            [ngStyle]="getCanvasSize(canvasContainer)"
            [hidden]="!displayItems.Histogram">
            <button 
                type="button" 
                class="position-absolute d-flex justify-content-center align-items-center icon-btn fill-white rounded-circle"
                style="top: 0; right: 0; height: 15px; width: 15px; padding: 3px; background-color: rgb(229, 229, 229); z-index: 2;"
                [hidden]="!(chartExpanded)"
                (click)="shrinkChart(canvasContainer)">
                <svg class="icon-12">
                    <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
            <canvas baseChart
                *ngIf="data.GraphData && data.GraphData.DisplayData && chartConfig"
                [id]="itemId + '_canvas'"
                class="cursor-pointer"
                (click)="expandChart(canvasContainer)"
                [type]="chartConfig.type"
                [legend]="chartConfig.options.plugins.legend.display"
                [datasets]="chartConfig.data.datasets"
                [labels]="chartConfig.data.labels"
                [options]="chartConfig.options"
                [plugins]="chartConfig.plugins"
                (chartHover)="displayTooltip($event)">
            </canvas>
        </div>
    </div>
    <div #trend class="d-flex justify-content-end align-items-center" *ngIf="displayItems.Changes">
        <div class="border-right pr-3 mr-3 text-center text-truncate" style="max-width: 100px;">
            <div class="font-size-12 bold" [ngStyle]="{color: data.Trend.Color}">
                <span [hidden]="(data.Trend.Direction <= 0)">&#x25B2;</span>
                <span [hidden]="(data.Trend.Direction >= 0)">&#x25BC;</span>
                <span [attr.title]="data.Trend.DisplayValue + '%'">{{data.Trend.DisplayValue}}%</span>
            </div>
            <div class="font-size-10 color-whaleTail text-capitalize" cvLocalizedText [langSection]="'KPI_Module'" [langKey]="'Change'" *ngIf="displayItems.Labels">change</div>
        </div>
        <div class="text-center text-truncate" style="max-width: 100px;">
            <div class="font-size-12 bold" [attr.title]="data.PreviousValue">{{data.PreviousValue}}</div>
            <div class="font-size-10 color-whaleTail text-capitalize" *ngIf="displayItems.Labels">{{data.PreviousLabel}}</div>
        </div>
    </div>
    <div class="d-flex flex-column" style="height: 20px;" *ngIf="displayItems.Objectives" [hidden]="chartExpanded">
        <cv-interactive-bar 
            class="mt-auto" 
            [data]="data.BarData" 
            (mouseover)="mouseover(trend.nativeElement)" 
            (mouseleave)="mouseleave(trend.nativeElement)">
        </cv-interactive-bar>
    </div>
</div>
